import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from 'App'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Mousewheel } from 'swiper/modules'
import 'swiper/css'
import { VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { secondData } from 'data/second'

interface ISecond {
  activeIndex: number,
  setIsNext: React.Dispatch<React.SetStateAction<boolean>>,
  setIsPrev: React.Dispatch<React.SetStateAction<boolean>>,
}

const Second = ({ activeIndex, setIsNext, setIsPrev }: ISecond) => {
  const { isTablet } = useContext(GlobalContext)
  const [swiperIdx, setSwiperIdx] = useState<number>(0)

  // eslint-disable-next-line
  useEffect(() => {
    if (activeIndex === 1) {
      if (swiperIdx === 0) {
        setIsNext(false)
        setTimeout(() => {
          setIsPrev(true)
        }, 400)
      }
      else if (swiperIdx === 2) {
        setIsPrev(false)
        setTimeout(() => {
          setIsNext(true)
        }, 400)
      }
    }
    else {
      setIsPrev(true)
      setIsNext(true)
    }
  }, [activeIndex, swiperIdx])

  const startAni1 = {
    opacity: 0,
    transform: 'translateX(-100px)',
  }

  const startAni2 = {
    opacity: 0,
    transform: 'translateX(100px)',
  }

  const endAni1 = {
    opacity: 1,
    transform: 'translateX(0)',
  }

  return (
    <div className="bg-black w-full h-screen overflow-hidden">
      <Swiper
        slidesPerView={1}
        mousewheel={true}
        modules={[Mousewheel]}
        onSlideChange={(swiper: any) => setSwiperIdx(swiper.activeIndex)}>
        {
          secondData.map((item, idx) => (
            <SwiperSlide className='bg-[#000] overflow-hidden' key={idx}>
              {
                idx === 1 ?
                  <div>
                    <div className="circle-wrapperPc">
                      <video
                        className={`video`}
                        muted
                        autoPlay
                        loop
                        playsInline
                        controls={isTablet}>
                        <source src="/video/intro.mp4" type="video/mp4" />
                      </video>
                    </div>
                    {
                      (item.id === swiperIdx && activeIndex === 1) &&
                      <div className='top-0 left-0 absolute flex justify-between items-center px-[7vw] w-full h-screen'>
                        <div>
                          {
                            item.title.map((title, index) => (
                              <motion.p
                                key={index}
                                className='mb-2 text-white text-8xl'
                                style={{ textShadow: '0 0 14px black' }}
                                transition={{ delay: 0.2 }}
                                initial={startAni1}
                                whileInView={endAni1}
                                viewport={VIEWPORT_PROPERTY} >
                                {title}
                              </motion.p>
                            ))
                          }
                        </div>

                        <motion.div
                          className='flex flex-col justify-center bg-[rgba(0,0,0,0.8)] pl-16 rounded-full w-[600px] h-[600px]'
                          transition={{ delay: 0.4 }}
                          initial={startAni2}
                          whileInView={endAni1}
                          viewport={VIEWPORT_PROPERTY} >
                          {
                            item.content.map((content, index) => (
                              <p key={index} className='text-white text-lg text-left'>{content}</p>
                            ))
                          }
                        </motion.div>
                      </div>
                    }
                  </div>
                  :
                  <div
                    style={{
                      backgroundImage: `url(${item.img})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      width: '100%',
                      height: 'calc(var(--vh, 1vh) * 100)',
                      maxWidth: '2540px',
                      margin: '0 auto'
                    }}>
                    {
                      (item.id === swiperIdx && activeIndex === 1) &&
                      <div className='flex justify-between items-center px-[7vw] h-screen'>
                        <div>
                          {
                            item.title.map((title, index) => (
                              <motion.p
                                key={index}
                                className='mb-2 text-white text-8xl'
                                style={{ textShadow: '0 0 14px black' }}
                                transition={{ delay: 0.2 }}
                                initial={startAni1}
                                whileInView={endAni1}
                                viewport={VIEWPORT_PROPERTY} >
                                {title}
                              </motion.p>
                            ))
                          }
                        </div>

                        <motion.div
                          className='flex flex-col justify-center bg-[rgba(0,0,0,0.8)] pl-16 rounded-full w-[600px] h-[600px]'
                          transition={{ delay: 0.4 }}
                          initial={startAni2}
                          whileInView={endAni1}
                          viewport={VIEWPORT_PROPERTY} >
                          {
                            item.content.map((content, index) => (
                              <p key={index} className='text-white text-lg text-left'>{content}</p>
                            ))
                          }
                        </motion.div>
                      </div>
                    }
                  </div>
              }
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div>
  )
}

export default Second
